import { render, staticRenderFns } from "./addItem.vue?vue&type=template&id=d9021726&scoped=true"
import script from "./addItem.vue?vue&type=script&lang=js"
export * from "./addItem.vue?vue&type=script&lang=js"
import style0 from "./addItem.vue?vue&type=style&index=0&id=d9021726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9021726",
  null
  
)

export default component.exports